import {collections} from './collections';

class PromotionCodeService {
    find = promotionCode =>
        collections().promotionCodes().where('code', '==', promotionCode).get();

    createNewCodeUsage = (promotionCodeId, data) =>
        collections().promotionCodesUsage(promotionCodeId).add(data);
}

export default new PromotionCodeService();
